(function () {
    angular
        .module('advancedapp')
        .component('newsCategoryFilterComponent', {
            restrict: 'E',
            bindings: {
                categoryResult: '<',
                industryResult: '<',
                newsTypeResult: '<',
                searchTerm: '<',
                onChange: '&',
                rootPageId: '<'
            },
            template: require('../news-category-filter/news-category-filter-component.html'),
            controller: controller,
            controllerAs: 'vm'
        });

    controller.$inject = ['$log', '$window', 'search_service'];

    function controller($log, $window, search_service) {

        var vm = this;
        vm.searchKeyword = document.getElementById('results-filter-search');
        var dateRangePicker = document.getElementById('news-category-filter-component-input-date');
        var mosaic = angular.element(dateRangePicker);
        mosaic.on('change', function (e) {
            // console.log(e.detail.dateStr);
            if (e.detail.selectedDates && e.detail.selectedDates.length === 2) {
                vm.searchModel.filterByDateRange = [e.detail.selectedDates[0], e.detail.selectedDates[1]];
                vm.change();
            }
        });

        vm.searchModel = {
            searchTerm: vm.searchKeyword.value,
            categories: [],
            sortBy: 0,
            rootPageId: vm.rootPageId,
            industryType: [],
            newsType: [],
            filterByIndustryTypeId: vm.selectedIndustry,
            filterByNewsTypeId: vm.selectedNews,
            filterByDateRange: [],
            numberToSkip: 0,
            numberToTake: 0,
            filterByAuthor: "",
            rootPage: null,
        };

        vm.selectedIndustry = vm.default;
        vm.selectedNews = vm.default;

        vm.$onChanges = function (changesObj) {
            if (changesObj.categoryResult && changesObj.categoryResult.currentValue) {
                vm.categories = changesObj.categoryResult.currentValue;
            }

            if (changesObj.industryResult && changesObj.industryResult.currentValue) {
                vm.industryType = changesObj.industryResult.currentValue;
            }

            if (changesObj.newsTypeResult && changesObj.newsTypeResult.currentValue) {
                vm.newsType = changesObj.newsTypeResult.currentValue;
            }

            if (changesObj.searchTerm && changesObj.searchTerm.currentValue) {
                vm.searchTerm = changesObj.searchTerm.currentValue;
            }

            if (changesObj.rootPageId && changesObj.rootPageId.currentValue) {
                vm.rootPageId = changesObj.rootPageId.currentValue;
                vm.searchModel.rootPageId = vm.rootPageId;
            }
        };

        vm.onSelectIndustry = function (selectedValue) {
            vm.searchModel.filterByIndustryTypeId = selectedValue;
            vm.change();
        };

        vm.onSelectNews = function (selectedValue) {
            vm.searchModel.filterByNewsTypeId = selectedValue;
            vm.change();
        };

        vm.change = function () {
            vm.searchModel.searchTerm = vm.searchKeyword.value;
            changeCat(vm.searchModel);
        };

        vm.toggle = false;

        vm.resetFilters = function () {
            vm.selectedNews = vm.default;
            vm.selectedIndustry = vm.default;
            dateRangePicker.value = "";
            vm.searchModel = {
                searchTerm: vm.searchKeyword.value,
                categories: [],
                sortBy: 0,
                rootPageId: vm.rootPageId,
                industryType: [],
                newsType: [],
                filterByIndustryTypeId: "",
                filterByNewsTypeId: "",
                filterByDateRange: []
            };
            changeCat(vm.searchModel);
        };

        function changeCat(model) {
            vm.onChange({ model });
        }
    }
})();